module.exports = __webpack_public_path__ + "img/icon-time-machine-start.c2780800.svg";